<template>
  <div id="app">
    <PageLoader/>
    <Header />
    <div class="flex1">
      <router-view />
    </div>
    <Footer />
    <a
      href="https://api.whatsapp.com/send?phone=5543999590178"
      target="_blank"
      class="fixed-whatsapp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
      >
        <path
          fill="#FFF"
          fill-rule="evenodd"
          d="M12.315 11.64c.339-.421.564-.632.677-.632.113 0 .536.19 1.27.568.733.38 1.122.607 1.165.685a.547.547 0 0 1 .026.194c0 .284-.074.611-.221.982-.14.336-.447.618-.925.846-.477.228-.92.342-1.328.342-.495 0-1.32-.267-2.474-.8A7.432 7.432 0 0 1 8.292 12.3c-.625-.629-1.268-1.426-1.927-2.39-.625-.922-.934-1.758-.925-2.507V7.3c.026-.784.347-1.465.964-2.042.208-.19.434-.284.677-.284.052 0 .13.007.234.02.104.012.187.019.248.019.164 0 .28.028.345.084.065.056.132.174.201.355.07.172.213.551.43 1.137s.326.909.326.97c0 .18-.15.428-.45.742-.3.314-.449.515-.449.6 0 .061.022.126.065.195.295.628.738 1.218 1.328 1.77.486.456 1.142.891 1.967 1.305.104.06.2.09.286.09.13 0 .365-.207.703-.62zm-1.966 6.215a8.01 8.01 0 0 0 3.17-.646 8.25 8.25 0 0 0 2.611-1.731 8.178 8.178 0 0 0 1.745-2.59 7.843 7.843 0 0 0 .651-3.146 7.843 7.843 0 0 0-.651-3.146 8.178 8.178 0 0 0-1.745-2.59 8.25 8.25 0 0 0-2.61-1.732 8.01 8.01 0 0 0-3.171-.646 8.01 8.01 0 0 0-3.17.646 8.25 8.25 0 0 0-2.611 1.731 8.178 8.178 0 0 0-1.745 2.59 7.843 7.843 0 0 0-.651 3.147c0 1.748.52 3.333 1.562 4.754l-1.028 3.01 3.15-.994a8.051 8.051 0 0 0 4.493 1.343zM6.534.775A9.65 9.65 0 0 1 10.349 0c1.328 0 2.598.258 3.809.775 1.21.517 2.254 1.21 3.131 2.08a9.834 9.834 0 0 1 2.096 3.108 9.403 9.403 0 0 1 .782 3.779c0 1.317-.26 2.577-.782 3.779a9.834 9.834 0 0 1-2.096 3.107c-.877.87-1.92 1.563-3.131 2.08a9.604 9.604 0 0 1-3.809.775 9.726 9.726 0 0 1-4.753-1.214L.166 20l1.771-5.233A9.453 9.453 0 0 1 .531 9.742c0-1.318.26-2.578.782-3.78a9.834 9.834 0 0 1 2.096-3.107A9.94 9.94 0 0 1 6.534.775z"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import PageLoader from "./components/PageLoader/PageLoader.vue";

export default {
  name: "App",
  data() {
    return {};
  },
  metaInfo() {
    return {
      title: "Fibrillare - Móveis de Alumínio e Fibra Sintética",
    };
  },
  components: {
    Header,
    Footer,
    PageLoader,
  },
};
</script>

<style lang="scss">
@import "./assets/css/animations.css";
@import "./assets/css/base.css";
@import "./assets/css/custom-carousel.css";
@import "./assets/css/layout.css";
@import "./assets/css/typo.css";
@import "./assets/css/hamburger.css";

#app {
  position: relative;
  display: flex;
  flex-direction: column;
}

.flex1 {
  flex-grow: 1;
  min-height: 100vh;
}

.fixed-whatsapp {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 10;
  border-radius: 50%;
  background: #4dc247;
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin-left: 1px;
    width: 30px;
    height: 30px;
  }
}

@media only screen and(max-width: 1440px) {
  .swiper-pagination {
    left: 60px !important;
  }
}

@media only screen and(max-width: 1024px) {
  .swiper-pagination {
    left: 20px !important;
  }
}

@media only screen and(max-width: 767px) {
  .swiper-navigation {
    display: none;
    left: 20px !important;
  }

  .swiper-pagination {
    left: 0 !important;
  }

  .hero .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 20% !important;
    transform: translate3d(0, -20%, 0) !important;
  }

  .blog-news-carousel .VueCarousel-navigation-prev {
    display: block;
    color: transparent !important;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("./assets/icons/prev-att-black.svg") !important;
    background-color: #fff !important;
    border: 1px solid #b3b3b3 !important;
    left: 140px !important;
    width: 44px;
    height: 44px;
    top: calc(100% + 35px) !important;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .blog-news-carousel .VueCarousel-navigation-next {
    display: block;
    color: transparent !important;
    background-image: url("./assets/icons/next-att-black.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff !important;
    border: 1px solid #b3b3b3 !important;
    right: 140px !important;
    top: calc(100% + 35px) !important;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .blog-news-carousel .VueCarousel-navigation--disabled {
    opacity: 0.5 !important;
  }

  .blog .blog-news-carousel .VueCarousel-navigation-prev {
    display: block;
    color: transparent !important;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("./assets/icons/prev-att-black.svg") !important;
    background-color: #fff !important;
    border: none;
    left: 140px !important;
    width: 44px;
    height: 44px;
    top: calc(100% + 34px) !important;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .blog .blog-news-carousel .VueCarousel-navigation-next {
    display: block;
    color: transparent !important;
    background-image: url("./assets/icons/next-att-black.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff !important;
    border: none;
    right: 140px !important;
    top: calc(100% + 34px) !important;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .blog .blog-news-carousel .VueCarousel-navigation--disabled {
    opacity: 0.5 !important;
  }

  .insta-carousel .VueCarousel-navigation-prev {
    display: block;
    color: transparent !important;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("./assets/icons/prev-att-black.svg") !important;
    background-color: #fff !important;
    border: none !important;
    left: 140px !important;
    width: 44px;
    height: 44px;
    top: calc(100% + 34px) !important;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .insta-carousel .VueCarousel-navigation-next {
    display: block;
    color: transparent !important;
    background-image: url("./assets/icons/next-att-black.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff !important;
    border: none !important;
    right: 145px !important;
    top: calc(100% + 34px) !important;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    opacity: 1;
    outline: none !important;
  }

  .insta-carousel .VueCarousel-navigation--disabled {
    opacity: 0.5 !important;
  }

  #tendencies-carousel .swiper-button-prev {
    top: 83%;
  }

  #tendencies-carousel .swiper-button-next {
    top: 83%;
  }
}

/*.router-link-exact-active::after {*/
/*    transition: all .3s;*/
/*    width: 100% !important;*/
/*    height: 2px;*/
/*    background: #fff;*/
/*    content: '';*/
/*    display: block;*/
/*    position: relative;*/
/*    top: 4px;*/
/*}*/

/*.router-link-active::after {*/
/*    transition: all .3s;*/
/*    width: 100% !important;*/
/*    height: 2px;*/
/*    background: #fff;*/
/*    content: '';*/
/*    display: block;*/
/*    position: relative;*/
/*    top: 4px;*/
/*}*/

.header-content__logo::after {
  display: none !important;
  width: 0;
}

.footer .blog-card {
  border-color: transparent !important;
}
</style>
